import { render, staticRenderFns } from "./Giftcard.vue?vue&type=template&id=89fcb3a0&"
import script from "./Giftcard.vue?vue&type=script&lang=js&"
export * from "./Giftcard.vue?vue&type=script&lang=js&"
import style0 from "./Giftcard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports